import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from './../../firebase/firebaseConfig';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import './../css/Login.css'

const AddGenderForm = () => {
  const [genderName, setGenderName] = useState('');
  const [genders, setGenders] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchGenders = async () => {
      const gendersCollection = collection(db, "gender");
      const genderSnapshot = await getDocs(gendersCollection);
      const genderList = genderSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setGenders(genderList);
    };

    fetchGenders();
  }, []);

  const validateGenderName = (name) => {
    const trimmedName = name.trim();
    if (trimmedName === '') {
      return 'Gender name cannot be empty.';
    }
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate gender name
    const validationError = validateGenderName(genderName);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const newGender = await addDoc(collection(db, "gender"), {
        gender_name: genderName
      });
      alert(`Gender "${genderName}" added successfully!`);
      setGenders([...genders, { id: newGender.id, gender_name: genderName }]);
      setGenderName('');
      setError(''); // Clear any previous errors
    } catch (e) {
      console.error("Error adding gender: ", e);
      alert('Error adding gender.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "gender", id));
      setGenders(genders.filter(gender => gender.id !== id));
      alert('Gender deleted successfully!');
    } catch (e) {
      console.error("Error deleting gender: ", e);
      alert('Error deleting gender.');
    }
  };

  return (
    <>
      <PageTitle title="Add Gender - ALMOSTINVISIBLE" />
      <Layout>
        <h1 className="unbounded">Gender</h1>
        <hr />
        <p className='unbounded fw-bold black-bordered-bottom'>Add Gender</p>
        <form onSubmit={handleSubmit}>
          <div>
                <div className="flex-column">
                    <label className='nunito-2'>Gender Name*</label>
                </div>
                <div className="inputForm">
                    <input
                        type="text"
                        value={genderName}
                        onChange={(e) => setGenderName(e.target.value)}
                        required
                        className="input"
                        style={{fontWeight: "bold"}}
                        placeholder='Enter the name of the gender category'
                    />
                </div>
                {error && <p className='error-message'>{error}</p>}
          </div>
          <br />
          <button type="submit" className='black-button'>Add Gender</button>
        </form>

        <hr />
        <div className='container'>
            <p className='unbounded fw-bold black-bordered-bottom'>List Of Genders</p>
            <ul>
              {genders.map((gender, index) => (
                <li key={gender.id} className='d-flex justify-content-between my-2'>
                  <span>{index + 1}. {gender.gender_name}</span>
                  <button className='red-button' onClick={() => handleDelete(gender.id)}>
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path>
                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"></path>
                      </svg>    
                      &nbsp; Delete
                  </button>
                </li>
              ))}
            </ul>
        </div>
      </Layout>
    </>
  );
};

export default AddGenderForm;
